import { render, staticRenderFns } from "./recent_searches_dropdown_content.vue?vue&type=template&id=99e988c8&"
import script from "./recent_searches_dropdown_content.vue?vue&type=script&lang=js&"
export * from "./recent_searches_dropdown_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports